module.exports = __webpack_public_path__ + "img/1525955651.8045f590.jpg";